import React from 'react';
import { DomainNameError, OfacRestricted } from './Statuses/DomainNameErrors';
export const domainNameErrorStatuses = {
  DOMAIN_TOO_SHORT: () => ({
    StatusComponent: () => {
      return /*#__PURE__*/React.createElement(DomainNameError, {
        translationKey: "domain_search_suite.error.one_character"
      });
    }
  }),
  TWO_CONSECUTIVE_DOTS: () => ({
    StatusComponent: () => {
      return /*#__PURE__*/React.createElement(DomainNameError, {
        translationKey: "domain_search_suite.error.two_periods"
      });
    }
  }),
  INVALID_DOMAIN_NAME: _ref => {
    let {
      domainName
    } = _ref;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(DomainNameError, {
          translationKey: "domain_search_suite.error.unrecognized_characters",
          args: {
            domainName
          }
        });
      }
    };
  },
  OFAC_TLD: _ref2 => {
    let {
      domainName
    } = _ref2;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(DomainNameError, null, /*#__PURE__*/React.createElement(OfacRestricted, {
          domainName: domainName
        }));
      }
    };
  },
  LABEL_INVALID_CHARS: _ref3 => {
    let {
      domainName
    } = _ref3;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(DomainNameError, {
          translationKey: "domain_search_suite.error.unrecognized_characters",
          args: {
            domainName
          }
        });
      }
    };
  },
  DOMAIN_TOO_LONG: _ref4 => {
    let {
      domainName
    } = _ref4;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(DomainNameError, {
          translationKey: "domain_search_suite.error.too_many_characters",
          args: {
            domainName
          }
        });
      }
    };
  },
  INVALID_DASH_USAGE: _ref5 => {
    let {
      domainName
    } = _ref5;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(DomainNameError, {
          translationKey: "domain_search_suite.error.hyphen_start_end",
          args: {
            domainName
          }
        });
      }
    };
  }
};
//# sourceMappingURL=domainNameErrorStatuses.js.map